import { useAppStateStore } from "@/stores/appState";
import { useEventStore } from "@/stores/event";
import { useAuthStore } from "@/stores/auth";
import { useWishStore } from "@/stores/wish";
import { usePreweddingStore } from "@/stores/prewedding";
import { useTemplateStore } from "@/stores/template";
import { usePromptpayStore } from "@/stores/promptpay";
import { useUserStore } from "@/stores/user";
import { useFontStore } from "@/stores/font";
import { i18n } from "~/plugins/i18n";
import { navigateTo } from "nuxt/app";

export const useBootstrapStore = defineStore("bootstrap", {
  state: () => ({
    isInit: false,
    failed: false,
    error: null as string | null,
  }),
  getters: {},
  actions: {
    async init() {
      if (this.isInit) {
        return;
      }

      const authStore = useAuthStore();

      // รอ auth plugin init เสร็จก่อน (ปกติ plugin client run ก่อน layout setup แล้ว
      // — กันกรณี race condition เผื่อไว้)
      if (!authStore.isReady) {
        return;
      }

      // ยังไม่ login (external browser) — ปล่อยให้ middleware เป็นคน redirect ไป LINE OAuth
      // ไม่ต้องทำอะไรที่นี่ และไม่ mark isInit เพื่อ retry ตอน auth ready
      if (!authStore.line?.userId) {
        return;
      }

      try {
        const userStore = useUserStore();
        await userStore.getUserById(authStore.line.userId);

        await this.managePath();

        const storageLang =localStorage.getItem("lang");
        if (storageLang) {
          i18n.global.locale.value = storageLang;
        }
      } catch (error: any) {
        this.error = error?.message || String(error);
        this.failed = true;
      } finally {
        this.isInit = true;
      }
    },

    consumeDeepLinkPath(): string | null {
      if (typeof window === "undefined") return null;
      const toPath = localStorage.getItem("toPath");
      if (!toPath) return null;
      localStorage.removeItem("toPath");

      const map: Record<string, string> = {
        upgrade: "/package/price",
        addUser: "/v3/invite-user",
        contact: "/v3/contact",
        write: "/v3/wish/linkQrcode",
        present: "/v3/realtime-slides/share",
        wish: "/v3/wish/list",
        promptpay: "/v3/promptpay/list",
        producebook: "/v3/produce-book",
      };
      return map[toPath] || null;
    },

    async managePath() {
      const authStore = useAuthStore();
      const userStore = useUserStore();

      // ถ้าเจอ user แล้วไปหน้า home ใช้งานได้เลย
      if (userStore.user) {
        await this.main();
        // Deep link จาก liff.state ถูกเก็บไว้ใน localStorage.toPath
        // → ถ้ามี ให้ไปหน้านั้นแทน home
        const deepLink = this.consumeDeepLinkPath();
        navigateTo(deepLink || "/v3/home");
        return;
      }

      //ถ้าเจอ user ไม่เจอ ไปหน้า validate
      if (!authStore.mobile) {
        return navigateTo("/auth/login-mobile");
      }

      //ถ้าเจอ user ไม่เจอ ไปหน้า validate
      const pre_register_data = await authStore.getPreRegisterData();
      if (authStore.mobile && !pre_register_data) {
        return navigateTo("/auth/register");
      }

      //ถ้าเจอ user ไม่เจอ ไปหน้า validate
      if (authStore.mobile && pre_register_data && !pre_register_data.invite) {
        return navigateTo("/auth/create-user");
      }

      //ถ้าเจอ user ไม่เจอ ไปหน้า validate
      if (authStore.mobile && pre_register_data && pre_register_data.invite) {
        return navigateTo("/auth/create-user?invite=true");
      }
    },

    async main() {
      const eventStore = useEventStore();
     
      const wishStore = useWishStore();
      const preweddingStore = usePreweddingStore();
      const promptpayStore = usePromptpayStore();
      const templateStore = useTemplateStore();
      const userStore = useUserStore();
      const fontStore = useFontStore();

      // const storageLang =localStorage.getItem("lang");

      try {
         
        await eventStore.main();
        eventStore.eventId =   userStore.user.eventId
        await eventStore.fetchEventRealtime();

        templateStore.fetchTemplateData();
        promptpayStore.fetchPromptpayRealtime(); // สำคัญ
        wishStore.fetchWishesRealtime(); // สำคัญ
        wishStore.fetchSortedWishesRealtime();

        preweddingStore.main();
        userStore.getUsersByEventId();
        fontStore.initGoogleFonts();
      } catch (error) {
        // location.reload();
      } finally {
        setTimeout(async () => {
          if(!wishStore.isFetched || !promptpayStore.isFetched) {
            await this.main()
          }
        }, 5000)
      }
    },

    async mainDesktop() {
           
       
      const eventStore = useEventStore();
      const preweddingStore = usePreweddingStore();
      const wishStore = useWishStore();
      const promptpayStore = usePromptpayStore();
      const templateStore = useTemplateStore();
      const fontStore = useFontStore();

      const storageLang =localStorage.getItem("lang");

      try {
        
        await eventStore.fetchEventRealtime();
        preweddingStore.main();
        wishStore.fetchWishesRealtime();
        wishStore.fetchSortedWishesRealtime();
        // ----
        templateStore.fetchTemplateData();
        promptpayStore.fetchPromptpayRealtime();
       
        await fontStore.initGoogleFonts();
        if (storageLang) {
          i18n.global.locale.value = storageLang;
        }
        // ------
      } catch (error) {
         debugger
      }
    },

    async mainEventBrand(eventId: string) {
      const eventStore = useEventStore();
      const wishStore = useWishStore();

      try {
        eventStore.eventId = eventId;

        await eventStore.fetchEventRealtime();
        wishStore.fetchWishesRealtime();
        wishStore.fetchSortedFavoriteWishesRealtime();
        wishStore.fetchSortedWishesRealtime();
        wishStore.fetchSortedWishesByIdRealtime();
      } catch (error) {
        location.reload();
      }
    },

    onUnmound() {
      const authStore = useAuthStore();
      const eventStore = useEventStore();
      const wishStore = useWishStore();
      const promptpayStore = usePromptpayStore();
      const templateStore = useTemplateStore();

      authStore.unSubscribeAuth();
      eventStore.unSubscribeEvent();
      templateStore.unSubscribeTemplate();
      promptpayStore.unSubscribePromptpay();
      wishStore.unSubscribeWish();
    },
  },
});
